import type { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * `min-w-0` is load-bearing, not cosmetic. ChartContainer carries shadcn's
 * `aspect-video`, which gives it a min-content width of height x 16/9 (533px
 * for a 300px-tall chart). A grid/flex item defaults to `min-width: auto` =
 * min-content, so without this the card refuses to shrink below ~583px and the
 * whole page scrolls horizontally on a phone. With `min-w-0` the card tracks
 * the column and the chart re-measures to fit.
 */
export function ChartCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <Card className="min-w-0">
      <CardHeader className="min-w-0">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
      </CardHeader>
      <CardContent className="min-w-0">{children}</CardContent>
    </Card>
  );
}
